import { _ } from "libs";

import React from "react";
import { MessagePartner } from "../../types";
import { formatName } from "../../libs/formatName";

const ConversationHeader = ({ partners }: { partners: MessagePartner[] }) => (
	<div className="conversationHeader">
		<div className="left" />
		<div className="title">
			{partners.length === 0 ? <span className="name">{_("chatBot.fullName")}</span> : null}
			{partners.length === 1 ? (
				partners[0].firstName && partners[0].firstName.length > 0 ? (
					<span className="name">{formatName(partners[0].firstName, partners[0].lastName)}</span>
				) : null
			) : null}
			{partners.length > 1 ? (
				<>
					{partners.map((partner, key) => (
						<span className="name" key={key}>
							{partner.firstName}
							{partners.length - 1 == key ? "" : ", "}
						</span>
					))}
					<span className="name"> {_("conversation.partnersAndMe")}</span>
				</>
			) : null}
		</div>
		<div className="right" />
	</div>
);

export default ConversationHeader;
